import { Chip, Grid, IconButton, Menu, MenuItem } from '@material-ui/core';
import { Description, Event, Group, MoreHoriz, Room, School, Work } from '@material-ui/icons';
import { useQuery } from '@webapps/reactjs-tech-components';
import { getTrainingById } from '@webapps/business';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import Team from 'components/Icons/Team';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import ReceivedDoc from '../../../../../../../libs/styles/src/lib/assets/images/ReceivedDoc';
import SendDoc from '../../../../../../../libs/styles/src/lib/assets/images/SendDoc';
import Training from './Training';
import CandidatsCardSkeleton from './CandidatsCardSkeleton';

const CandidatsCard = ({
  cancelAffiliation,
  id,
  item,
  transfertDocument,
  viewAffiliation,
  viewMember,
  setOpenMessageBox,
  setCandidatId,
  isLoading = false,
}) => {
  if (isLoading) return <CandidatsCardSkeleton />;

  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [anchorAffiliation, setAnchorAffiliation] = useState(null);
  const openAffiliationMenu = Boolean(anchorAffiliation);

  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', item?.classroom?.training],
    variables: { id: item?.classroom?.training },
  });

  const handleContact = (id) => {
    setCandidatId(id);
    setOpenMessageBox(true);
  };

  return (
    <Grid item className={classes.container}>
      <div>
        <div
          style={{
            padding: spacing(2.5),
            borderRadius: 10,
            backgroundColor: '#FFF',
          }}
        >
          <div>
            <div>
              <div className={classes.infoCandidat}>
                <div>
                  <AvatarStudent applicant={item?.student} />
                </div>
                <div
                  className={css({
                    marginLeft: spacing(1.5),
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    width: '100%',
                  })}
                >
                  <div className={classes.divStudent}>
                    <div style={{ display: 'flex' }} className={global.title}>
                      <span style={{ marginRight: spacing(1) }}>
                        {item?.student?.lastname}
                      </span>
                      {item?.student?.firstname}
                    </div>
                    <div>
                      <IconButton
                        onClick={(e) => setAnchorAffiliation(e.currentTarget)}
                        size="24px"
                        aria-controls={'menu'}
                        style={{
                          margin: '0px 3px',
                          alignSelf: 'baseline',
                          borderRadius: '20px',
                          border: '1px solid #C0D9FF',
                          backgroundColor: '#F3F7FF',
                          width: '26px',
                          display: 'flex',
                          justifyContent: 'center',
                          height: '26px',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                      >
                        <MoreHoriz
                          style={{ color: '#5A6DA1', fontSize: '15.00px' }}
                        />
                      </IconButton>
                      <Menu
                        anchorEl={anchorAffiliation}
                        id="menu"
                        open={openAffiliationMenu}
                        onClose={() => setAnchorAffiliation(false)}
                        onClick={() => setAnchorAffiliation(false)}
                        PaperProps={{ elevation: 2 }}
                        transformOrigin={{ horizontal: 'left', vertical: -50 }}
                        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                      >
                        <MenuItem onClick={() => viewMember(id)}>
                          Voir le profil
                        </MenuItem>

                        {item.status === 'CREATED' &&
                          item.additionalFiles?.map((item) => {
                            if (item.uploaded === false)
                              return (
                                <MenuItem onClick={() => transfertDocument(id)}>
                                  <FormattedMessage id="school.formationsCandidats.transfererDocument" />
                                </MenuItem>
                              );
                          })}
                        {item.status !== 'REJECTED' &&
                          item.status !== 'CANCELED' &&
                          item.status !== 'BROKEN' &&
                          item.status !== 'ENCLOSED' &&
                          item.status !== 'CONTRACT-BROKEN' &&
                          item.status !== 'CREATED' && [
                            <MenuItem onClick={() => viewAffiliation(id)}>
                              Valider l'affiliation
                            </MenuItem>,
                          ]}
                        {item.status !== 'REJECTED' &&
                          item.status !== 'CANCELED' &&
                          item.status !== 'BROKEN' &&
                          item.status !== 'ENCLOSED' &&
                          item.status !== 'CONTRACT-BROKEN' && [
                            <MenuItem onClick={() => cancelAffiliation(id)}>
                              Annuler l'affiliation
                            </MenuItem>,
                          ]}
                      </Menu>
                    </div>
                  </div>
                  <div className={cx(global.infoText, classes.address)}>
                    <Room className={classes.roomIcon} />
                    <div className={css({ marginLeft: '16px' })}>
                      {item?.student?.address?.cityCode}{' '}
                      {item?.student?.address?.city}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div style={{ padding: spacing(1) }}>
                <div className={cx(global.infoText, classes.address)}>
                  <Team className={classes.iconWidth} />
                  <div>
                    {item?.classroom?.label}
                  </div>
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <School className={classes.iconWidth} />
                  {training?.degree?.level?.label}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <Work className={classes.iconWidth} />
                  {training?.label}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <Description className={classes.iconWidth} />
                  {training?.trainingType?.label}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <SendDoc className={classes.iconWidth} />
                  <div>
                    {item?.requiredFiles?.length + ' ' + 'Documents demandés'}
                  </div>
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <ReceivedDoc className={classes.iconWidth} />
                  <div>
                    {item?.requiredFiles?.filter(({ uploaded }) => uploaded)
                      .length +
                      ' ' +
                      'Documents récéptionnés'}
                  </div>
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <Event className={classes.iconWidth} />
                  <FormattedDate
                    day="numeric"
                    month="long"
                    value={item?.createAt}
                    year="numeric"
                  />
                </div>
              </div>
              <div className={classes.chipContainer}>
                {item?.status === 'CREATED' ? (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#FAE8D7 ',
                        color: '#FA8100',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Statut : En attente de l'apprenant"
                  />
                ) : item?.status === 'ACCEPTED' ? (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#FAE8D7 ',
                        color: '#FA8100',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Statut : En attente de votre validation ⚠️"
                  />
                ) : item?.status === 'REJECTED' ? (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#fbd3d5',
                        color: '#F50057',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Statut : Annulée par vous"
                  />
                ) : item?.status === 'HALF-REJECTED' ? (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#FAE8D7 ',
                        color: '#FA8100',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Statut : En attente de document(s)"
                  />
                ) : item?.status === 'CANCELED' ? (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#fbd3d5',
                        color: '#F50057',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Statut : Annulé par vous"
                  />
                ) : item?.status === 'BROKEN' ? (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#fbd3d5',
                        color: '#F50057',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Statut : Annulé par l'apprenant"
                  />
                ) : (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#DBFAD8',
                        color: '#008000',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Statut : Acceptée"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: spacing(2.5, 2.5, 0, 0),
  },
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'start', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(0.5),
    position: 'relative'
  },
  chip: {
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    borderRadius: '10.0px',
    '@media only screen and (max-width:768px)': {
      fontSize: 12,
      padding: 0,
      maring: 0,
    },
  },
  chipContainer: {
    marginBottom: spacing(0),
  },
  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  iconWidth: {
    width: '20px',
    height: '20px',
    marginRight: spacing(1),
  },
  roomIcon: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: -5,
    color: '#5D75A8',
  }
});

CandidatsCard.propTypes = {
  cancelAffiliation: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  transfertDocument: PropTypes.func.isRequired,
  viewAffiliation: PropTypes.func.isRequired,
  viewMember: PropTypes.func.isRequired,
  setOpenMessageBox: PropTypes.func.isRequired,
  setCandidatId: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default CandidatsCard;
